module.exports = __webpack_public_path__ + "img/pin-end2.58814961.png";